import VerifyOutTransferReturn from "../../../../components/@documents/transfer_returns/VerifyOutTransferReturn";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function TransferReturnVerifyOutPage() {

    return (
        <VerifyOutTransferReturn 
            routeType={routeTypes.admin}
        />
    )
}